import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NonWorkingDaysComponent } from './non-working-days.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddNonWorkingDaysComponent } from './add-non-working-days/add-non-working-days.component';
import { EditNonWorkingDaysComponent } from './edit-non-working-days/edit-non-working-days.component';

@NgModule({
    declarations: [NonWorkingDaysComponent, AddNonWorkingDaysComponent, EditNonWorkingDaysComponent],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [NonWorkingDaysComponent],
})
export class NonWorkingDaysModule { }
